import { HttpClient } from '@wix/http-client';

import {
  baseURL,
  metaSiteId,
  siteId,
  pMetaSiteId,
  editorType,
  siteName,
  feedbackCreatorUserGuid,
  ownerId,
  isOwner,
  origin,
} from '../fromWindow';

const httpClient = new HttpClient({ baseURL });

export const SEND_SHARED_LINK = `/sendShareEmail/${metaSiteId}?siteId=${siteId}`;
export const UPDATE_COMMENT = `/feedback/updateComment`;
export const REPLY_TO_COMMENT = `/feedback/replyToComment`;
export const DELETE_REPLY_TO_COMMENT = `/feedback/deleteReplyToComment`;
export const UPDATE_REPLY_TO_COMMENT = `/feedback/updateReplyToComment`;
export const SV_SESSION_GENERATOR = `/feedback/svSessionGenerator`;
export const SV_SESSION_CHECK = `/feedback/checkSvSession`;
export const GET_SHARE_MODAL_DETAILS = `/enrichModelDataAndSaveToCloudStore`;

/**
 * Sends the share-feedback invitation emails.
 *
 * Server contract: the body carries a Wix captcha token (reCAPTCHA Enterprise)
 * that the `sendShareEmail` route MUST authorize via
 * `@wix/ambassador-captcharator-v1-captcha-entity` `authorize()` before sending.
 * A missing/invalid/expired token fails with a 403 and sends nothing. The
 * rate-limit throttle on the route stays as a complementary layer.
 */
export const sendSharedLink = async (payload, captchaToken) => {
  const { data } = await httpClient.post(`${SEND_SHARED_LINK}`, {
    payload,
    captchaToken,
  });
  if (data.error) {
    throw new Error(data.error);
  }
  return data.status.length;
};

export const updateComment = async ({
  id,
  feedbackId,
  message,
  commentLocation,
  commenterId,
  status,
  revision,
  fields,
}) => {
  const { data } = await httpClient.post(`${UPDATE_COMMENT}`, {
    feedbackId,
    commentId: id,
    metaSiteId,
    commenterId,
    comment: {
      message,
      commentLocation,
      status,
      revision,
    },
    fields,
  });
  return data.comment;
};

export const replyToComment = async ({
  id,
  feedbackId,
  revision,
  replyText,
  userInfo,
  commenterId,
}) => {
  const { data } = await httpClient.post(`${REPLY_TO_COMMENT}`, {
    feedbackId,
    commentId: id,
    metaSiteId,
    revision,
    isOwner,
    siteName,
    ownerId,
    feedbackCreatorUserGuid,
    editorType,
    siteId,
    commenterInfo: userInfo,
    commenterId,
    reply: {
      message: replyText,
    },
    pMetaSiteId,
  });

  return data.comment;
};

export const deleteReplyToComment = async ({
  commentId,
  feedbackId,
  revision,
  replyId,
  commenterId,
}) => {
  const { data } = await httpClient.post(`${DELETE_REPLY_TO_COMMENT}`, {
    feedbackId,
    commentId,
    metaSiteId,
    commenterId,
    revision,
    isOwner,
    pMetaSiteId,
    replyId,
  });
  return data.comment;
};

export const updateReplyToComment = async ({
  commentId,
  feedbackId,
  message,
  replyId,
  commenterId,
  revision,
}) => {
  const {
    data: { comment },
  } = await httpClient.post(`${UPDATE_REPLY_TO_COMMENT}`, {
    feedbackId,
    commentId,
    metaSiteId,
    message,
    commenterId,
    revision,
    replyId,
  });
  return comment;
};

export const sessionGenerator = async () => {
  const { data } = await httpClient.get(SV_SESSION_GENERATOR);
  return data;
};

export const checkSvSession = async () => {
  const { data } = await httpClient.get(SV_SESSION_CHECK);
  return data;
};

export const getShareModalDetails = async () => {
  const { data } = await httpClient.get(
    `${GET_SHARE_MODAL_DETAILS}?siteId=${siteId}&metaSiteId=${metaSiteId}&origin=${origin}`,
  );
  return data;
};
